import React, { useState } from 'react';
import { Container, Button, Stack } from '@mui/material';

import Page from 'src/components/Page';
import PlanList from './PlanList';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import SubscriptionPlanManagement from '../dashboard/SubscriptionPlanManagement';
import HubspotContactForm from 'src/components/forms/HubspotContactForm';
import { contactFormConfig } from 'src/components/forms/hubspot-config';
import { PlanType } from 'src/@types/feature';
import { StyledPlansContainer } from './styles';
import CurrencySelector from 'src/components/locales/CurrencySelector';
import useSubscriptions from 'src/hooks/useSubscriptions';
import { AppGridContent, AppTypography, StackRow, AppSection, StackRowForm } from 'src/components';

//
//

export default function PlansPage() {
  const {
    subscriptionPlans,
    onCancelButtonClick,
    onUpdatePaymentMethod,
    isPremiumUser,
    isCurrentPlanEnterprise,
    isPlansLoading,
    subscriptionsAreLoading,
    isStripeSubscription,
    planCurrency,
    setPlanCurrency,
    availablePlanCurrencies,
  } = useSubscriptions();

  const [selectedBtn, setSelectedBtn] = useState(PlanType.MONTHLY);
  const [isOpenContactModal, setIsOpenContactModal] = useState(false);
  const [updateBillingMethodIsLoading, setUpdateBillingMethodIsLoading] = useState(false);

  return (
    <Page title="Subscriptions">
      <Container maxWidth={false}>
        <HeaderBreadcrumbs links={[{ name: 'Account' }, { name: 'Subscription plans' }]} />

        <StyledPlansContainer mb={2} flexWrap='wrap-reverse'>
          <AppGridContent size={{ xs: 12, md: 4 }} />

          <AppGridContent size={{ xs: 12, sm: 6, md: 4 }}>
            <StackRow gap={1} justifyContent="center">
              <Button
                onClick={() => setSelectedBtn(PlanType.MONTHLY)}
                color={selectedBtn === PlanType.MONTHLY ? 'primary' : 'secondary'}
                variant='contained'
              >
                MONTHLY
              </Button>
              <Button
                onClick={() => setSelectedBtn(PlanType.ANNUAL)}
                color={selectedBtn === PlanType.ANNUAL ? 'primary' : 'secondary'}
                variant='contained'
              >
                ANNUAL
              </Button>
            </StackRow>
          </AppGridContent>

          {(!isPremiumUser && !subscriptionsAreLoading && !isPlansLoading) ?
            <AppGridContent size={{ xs: 12, sm: 6, md: 4 }} className='currencySelector'>
              <Stack spacing={1} direction='row'>
                <AppTypography variant='caption'>CHOOSE YOUR CURRENCY</AppTypography>
                <CurrencySelector
                  currencies={availablePlanCurrencies}
                  currency={planCurrency}
                  selectedCurrency={setPlanCurrency}
                />
              </Stack>
            </AppGridContent> : null
          }
        </StyledPlansContainer>

        <Stack spacing={3}>
          <PlanList
            selectedBtn={selectedBtn}
            subscriptionPlans={subscriptionPlans}
          />

          <SubscriptionPlanManagement />

          {isPremiumUser && !isCurrentPlanEnterprise && 
            <AppSection title='Manage payment and billing' border>
                <AppTypography sx={{ mb: 1.5 }}>Manage your payment details</AppTypography>

                <StackRowForm alignItems="flex-start" gap={{ xs: 1, sm: 2 }}>
                  <Button
                    variant="outlined"
                    loading={updateBillingMethodIsLoading}
                    onClick={() => {
                        if (!subscriptionsAreLoading && isStripeSubscription) {
                            setIsOpenContactModal(true)
                        } else {
                            setUpdateBillingMethodIsLoading(true)
                            onUpdatePaymentMethod()
                                .catch(() => {
                                    setUpdateBillingMethodIsLoading(false);
                                });
                        }
                    }}
                    size='small'
                  >
                    Manage billing information
                  </Button>
                  <Button
                    onClick={() => {
                      !subscriptionsAreLoading && isStripeSubscription
                        ? setIsOpenContactModal(true)
                        : onCancelButtonClick()
                    }}
                    size='small'
                  >
                    Cancel subscription
                  </Button>
                </StackRowForm>
            </AppSection>
          }

        </Stack>
      </Container>

      {isOpenContactModal && (
        <HubspotContactForm
          isModalOpen={isOpenContactModal}
          setIsModalOpen={setIsOpenContactModal}
          region={contactFormConfig.region}
          portalId={contactFormConfig.portalId}
          formId={contactFormConfig.formId}
        />
      )}
    </Page>
  );
}
